import { Icon } from "@ui/components/icon/icon";
import React, { ReactNode } from "react";

interface Props {
    title: ReactNode;
    point1: ReactNode;
    point2: ReactNode;
    isDefaultOpen: boolean;
}

export function PackageItem(props: Props) {
    return (
        <details className="group" open={props.isDefaultOpen}>
            <summary className="cursor-pointer list-none [&::-webkit-details-marker]:hidden">
                <div className="flex items-center gap-4 pb-6">
                    <p className="font-bold text-uxfVioletDark underline">{props.title}</p>
                    <Icon className="text-primary-jumbotron group-open:rotate-180" size={16} name="chevronDown" />
                </div>
            </summary>
            <ul className="list-disc pb-6 pl-6 text-uxfMuted75">
                <li>{props.point1}</li>
                <li>{props.point2}</li>
            </ul>
        </details>
    );
}
